import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    invoices: [],
    invoice: null,
    invoiceItem: null,
    invoiceFilters: null,
    invoiceStatuses: null,
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
